// STATE 
export const showContentUploaderForm = '';

// REDUCER
export const ShowContentUploaderFormReducer = (state, action) => {
    switch (action.type) {
        case 'openContentUploaderForm':
            return true
        case 'closeContentUploaderForm':
            return false
        default:
            return false
    }
}
